// Pass the arguments for asset link and title of the downloaded file
export function downloadAsset(assetlink, title) {
  fetch(assetlink, {
    method: "GET",
  })
    .then(response => response.blob())
    .then(blob => {
      const filetype = blob.type.split(/[ /]+/)[1] // this gets the assert format/type form response to set in extension
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `${title}.${filetype}`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    })
}
